
import { defineComponent } from 'vue';

//import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from '@/components/kt-datatable/KTDatatable.vue';
import SearchTable from '@/components/wizard/SearchTable.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import * as Yup from 'yup';
import ApiService from '@/core/services/ApiService';
import moment from 'moment';
import { VueCookieNext } from 'vue-cookie-next';
import { ElBadge } from 'element-plus';

export default defineComponent({
  name: 'add-claim-1',
  components: {
    Datatable,
    SearchTable,
  },
  data() {
    return {
      bill: {
        course_type: '',
        tranche_id: '',
        entity_id: '',
        entity_contract_id: '',
        start_date: '',
        training_institute_id: '',
        course_info_id: '',
        batch_info_id: '',
        bill_sequence_no: '',
      },
      courseTypes: [],
      selectedBatch: [],
      tranches: [],
      entityInfos: [],
      contractInfos: [],
      institutes: [],
      courses: [],
      batches: [],
      BatchList: [],
      billList: [],
      allBill: [
        {
          trainee_count: '',
          bill_amount: '',
          contribution_percentage: '',
          contribution_amount: '',
          net_payable: '',
        },
      ],

      claimBillkey: 0,
      claimBillBatchkey: 0,
      tolatTrainee: 0,
      tolatBillAmount: 0,
      contributionPay: 0,
      totalContributionAmount: 0,
      totalPayableAmount: 0,
      loading: false,
      load: false,
      courseInfoData: false,
      showBillInfo: false,
      showBillList: false,
      showBatchList: false,
      showtrainingProviderNotice: false,
    };
  },
  async created() {
    await this.getCourseTypes();
    await this.getTranche();
    this.moment = moment;
    this.bill.start_date = moment().format('YYYY-MM-DD');
    this.emitter.on('claim-1-bill-update', async () => {
      await this.getBillList();
    });
    this.emitter.on('claim-1-bill-batch-list-update', async () => {
      await this.eligibleBatchList();
    });
  },
  methods: {
    async getCourseTypes() {
      this.load = true;
      await ApiService.get('configurations/course_type/list')
        .then((response) => {
          this.courseTypes = response.data.data;
          this.courseTypes.length = 2;
          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getTranche() {
      await ApiService.get('configurations/tranche/list')
        .then((response) => {
          this.tranches = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getAssociation() {
      this.billListShow();
      this.load = true;
      let entity_id = '';
      if (VueCookieNext.getCookie('_seip_entity_type') != 1004) {
        entity_id = VueCookieNext.getCookie('_entity_id');
      }
      await ApiService.get('entity/list?entity_id=' + entity_id)
        .then((response) => {
          this.entityInfos = response.data.data;
          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getEntityContract() {
      this.billListShow();
      this.load = true;
      await ApiService.get(
        'entity/contract/list?entity_info_id=' +
          this.bill.entity_id +
          '&tranche_id=' +
          this.bill.tranche_id
      )
        .then((response) => {
          this.contractInfos = response.data.data;
          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getBillSequenceNo() {
      let institute_info_id = '';
      if (VueCookieNext.getCookie('_seip_entity_type') == 1011) {
        institute_info_id = VueCookieNext.getCookie('_institute_info_id');
      }
      this.eligibleBatchList();
      await ApiService.get(
        'bill/claim_1/sequence_no?entity_id=' +
          this.bill.entity_id +
          '&tranche_id=' +
          this.bill.tranche_id +
          '&entity_contract_id=' +
          this.bill.entity_contract_id +
          '&institute_info_id=' +
           institute_info_id
      )
        .then((response) => {
          this.bill.bill_sequence_no = response.data.data;
          this.emitter.emit('claim-1-bill-update', true);
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async eligibleBatchList() {
      let institute_info_id = '';
      if (VueCookieNext.getCookie('_seip_entity_type') == 1011) {
        institute_info_id = VueCookieNext.getCookie('_institute_info_id');
      }
      this.load = true;
      await ApiService.get(
        'bill/claim_1/enroll_batch?entity_id=' +
          this.bill.entity_id +
          '&tranche_id=' +
          this.bill.tranche_id +
          '&course_type=' +
          this.bill.course_type +
          '&institute_info_id=' +
           institute_info_id+
           '&entity_contract_id=' +
          this.bill.entity_contract_id
      )
        .then((response) => {
          this.BatchList = response.data.data;
          this.showBatchList = true;
          this.claimBillBatchkey += 1;
          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    // async trainingInstitute() {
    //   await ApiService.get("institute/list?entity_id=" + this.bill.entity_id)
    //     .then((response) => {
    //       this.institutes = response.data.data;
    //     })
    //     .catch(({ response }) => {
    //       console.log(response);
    //     });
    // },
    // async getCourseList() {
    //   await ApiService.get(
    //     "course/list?entity_id=" +
    //       this.bill.entity_id +
    //       "&tranche_id=" +
    //       this.bill.tranche_id +
    //       "&training_institute_id=" +
    //       this.bill.training_institute_id+
    //       "&course_type=" +
    //       this.bill.course_type
    //   )
    //     .then((response) => {
    //       this.courses = response.data.data;
    //     })
    //     .catch(({ response }) => {
    //       console.log(response);
    //     });
    // },
    async getBatchList() {
      await ApiService.get(
        'bill/claim_1/enroll_batch?entity_id=' +
          this.bill.entity_id +
          '&tranche_id=' +
          this.bill.tranche_id +
          '&institute_info_id=' +
          this.bill.training_institute_id +
          '&course_info_id=' +
          this.bill.course_info_id+
          '&entity_contract_id=' +
          this.bill.entity_contract_id
      )
        .then((response) => {
          this.batches = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getBillList() {
      let institute_info_id = '';
      if (VueCookieNext.getCookie('_seip_entity_type') == 1011) {
        institute_info_id = VueCookieNext.getCookie('_institute_info_id');
      }
      this.load = true;
      this.tolatTrainee = 0;
      this.tolatBillAmount = 0;
      this.contributionPay = 0;
      this.totalContributionAmount = 0;
      this.totalPayableAmount = 0;
      await ApiService.get(
        'bill/claim_1/list?entity_id=' +
          this.bill.entity_id +
          '&tranche_id=' +
          this.bill.tranche_id +
          '&entity_contract_id=' +
          this.bill.entity_contract_id  +
          '&institute_info_id=' +
           institute_info_id +
          '&course_parent_type=' +
          this.bill.course_type +
          '&active_status=1'
      )
        .then((response) => {
          this.billList = response.data.data;
          this.allBill = response.data.data;
          this.allBill.forEach((el) => {
            this.tolatTrainee += ~~el.trainee_count;
            this.tolatBillAmount += parseFloat(el.bill_amount);
            this.contributionPay = parseFloat(el.contribution_percentage);
            this.totalContributionAmount += parseFloat(el.contribution_amount);
            this.totalPayableAmount += parseFloat(el.net_payable);
          });
          this.claimBillkey += 1;
          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
          this.load = false;
        });
    },
    async addAllToClaim() {
      if (this.selectedBatch.length === 0) {
        Swal.fire({
          title: 'Error!',
          html: 'Please select a batch.',
          icon: 'error',
          buttonsStyling: false,
          confirmButtonText: 'Close',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        }).then(() => {
          this.loading = false;
        });
      } else {
        Swal.fire({
          title: 'Are you sure to send these batch to claim list ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Submit!',
        }).then((result) => {
          if (result.isConfirmed) {
            let data = {
              tranche_id: this.bill.tranche_id,
              entity_id: this.bill.entity_id,
              entity_contract_id: this.bill.entity_contract_id,
              course_type: this.bill.course_type,
              bill_sequence_no: this.bill.bill_sequence_no,
              start_date: this.bill.start_date,
              batch_list: this.selectedBatch,
            };
            this.loading = true;
            ApiService.post('bill/claim_1/save', data)
              .then((response) => {
                this.loading = false;
                if (response.status == 200) {
                  Swal.fire({
                    title: 'Success!',
                    text: response.data.data,
                    icon: 'success',
                    buttonsStyling: false,
                    confirmButtonText: 'Ok',
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  }).then(() => {
                    this.bill.batch_info_id = '';
                    this.selectedBatch = [];
                    this.getBatchList();
                    this.emitter.emit('claim-1-bill-update', true);
                    this.emitter.emit('claim-1-bill-batch-list-update', true);
                  });
                } else {
                  let err = '';
                  for (const field of Object.keys(response.data.errors)) {
                    err += response.data.errors[field][0] + '<br>';
                  }
                  Swal.fire({
                    title: 'Please check all the required field',
                    html: err,
                    icon: 'error',
                    buttonsStyling: false,
                    confirmButtonText: 'Close',
                    customClass: {
                      confirmButton: 'btn btn-danger',
                    },
                  });
                }
              })
              .catch(({ response }) => {
                this.loading = false;
                Swal.fire({
                  title: 'Unknown error',
                  html: response.data.error,
                  icon: 'error',
                  buttonsStyling: false,
                  confirmButtonText: 'Close',
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                });
                console.log(response);
              });
          } else {
            this.loading = false;
          }
        });
      }
    },
    async addClaim() {
      let data = {
        tranche_id: this.bill.tranche_id,
        entity_id: this.bill.entity_id,
        entity_contract_id: this.bill.entity_contract_id,
        institute_info_id: this.bill.training_institute_id,
        course_info_id: this.bill.course_info_id,
        batch_info_id: this.bill.batch_info_id,
        course_type: this.bill.course_type,
        bill_sequence_no: this.bill.bill_sequence_no,
        start_date: this.bill.start_date,
      };

      this.loading = true;
      await ApiService.post('bill/claim_1/save', data)
        .then((response) => {
          this.loading = false;
          if (response.status == 200) {
            this.emitter.emit('claim-1-bill-update', true);
            Swal.fire({
              title: 'Success!',
              text: response.data.data,
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: 'Ok',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            }).then(() => {
              this.bill.batch_info_id = '';
              this.getBatchList();
            });
          } else {
            let err = '';
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + '<br>';
            }
            Swal.fire({
              title: 'Please check all the required field',
              html: err,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Close',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            });
          }
        })
        .catch(({ response }) => {
          this.loading = false;
          Swal.fire({
            title: 'Unknown error',
            html: response.data.error,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Close',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          });
          console.log(response);
        });
    },
    async submitBill() {
      let user_id = VueCookieNext.getCookie('_seip_user');
      user_id =  user_id.id;

      let data = {
        tranche_id: this.bill.tranche_id,
        entity_id: this.bill.entity_id,
        course_type: this.bill.course_type,
        entity_contract_id: this.bill.entity_contract_id,
        bill_sequence_no: this.bill.bill_sequence_no,
        start_date: this.bill.start_date,
        user_id: user_id,
      };

      this.loading = true;
      await ApiService.post('bill/claim_1/bill_submit', data)
        .then((response) => {
          this.loading = false;
          if (response.status == 200) {
            Swal.fire({
              title: 'Success!',
              text: response.data.data,
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: 'Ok',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            }).then(() => {
              this.bill.tranche_id = '';
              this.bill.entity_id = '';
              this.bill.course_type = '';
              this.bill.entity_contract_id = '';
              this.bill.bill_sequence_no = '';
              this.showBillInfo = false;
              this.showBillList = false;
              this.showBatchList = false;
              this.getBatchList();
              this.emitter.emit('claim-1-bill-update', true);
            });
          } else {
            let err = '';
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + '<br>';
            }
            Swal.fire({
              title: 'Please check all the required field',
              html: err,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Close',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            });
          }
        })
        .catch(({ response }) => {
          this.loading = false;
          Swal.fire({
            title: 'Unknown error',
            html: response.data.error,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Close',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          });
          console.log(response);
        });
    },
    confirmSubmitBill() {
      Swal.fire({
        title: "You can't edit bill after submit. Are you sure to submit ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Submitted!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitBill();
        }
      });
    },
    Delete(id) {
      Swal.fire({
        title: 'Are you sure you want to delete it?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete!',
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.delete('bill/claim_1/delete/' + `${id}`)
            .then((response) => {
              Swal.fire('Deleted!', response.data.data, 'success').then(() => {
                this.emitter.emit('claim-1-bill-update', true);
                this.bill.batch_info_id = '';
                this.getBatchList();
                this.eligibleBatchList();
              });
            })
            .catch(({ response }) => {
              console.log(response);
            });
        }
      });
    },
    moment() {
      return moment();
    },
    billListShow() {
      this.showBillInfo = true;
      this.showBillList = false;
      this.showBatchList = false;
    },
  },
  setup() {},
});
